<template>
    <div>
        <div>
            <el-select v-model="status" placeholder="请选择状态">
                <el-option
                        v-for="item in status_types"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                </el-option>
            </el-select>
        </div>
        <div  style="text-align: right">
            <el-button @click="handleChangeStatus">确定</el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_SignLog",
        data() {
            return {
                status_types:[{
                    id: 'active',
                    name: '未上'
                },{
                    id: 'finished',
                    name: '签到'
                },{
                    id: 'absent',
                    name: '缺席'
                }],
                status:''
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            if(['active','finished','absent'].includes(this.$store.state.modal.data.status)){
                this.status=this.$store.state.modal.data.status;
            }
        },
        methods: {
            handleChangeStatus(){
                this.$wApi.send(this.$parentInfo.signPath, 'change_classPlanStudent_status', {
                    'classPlanStudent_id': this.$store.state.modal.data.classPlanStudent_id,
                    'student_id': this.$store.state.modal.data.student_id,
                    'status': this.status,
                    'type': this.$store.state.modal.data.type,
                });
            }
        }
    }
</script>

<style scoped>

</style>